import { GridColDef } from "@mui/x-data-grid-pro";
import { GKDataGrid, Grid2, NoData, RevenueIcon, Typography } from "components";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";
import { useNavigate } from "react-router-dom";
import { useSetUpFeePlanFlowQuery } from "store/features/Revenue/FeePlan";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch } from "store/store";
import { moneyCommaSeparator } from "utils";
import { extraColumnsField, matchDate } from "utils/helpers";

const RevenueManager = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const requestBody = useGenerateQueryParams("portfolioMapping");
  const { data, isFetching } = useSetUpFeePlanFlowQuery(requestBody);

  const columns: GridColDef[] = [
    {
      ...extraColumnsField(
        `Portfolio Name (${data?.totalCount || 0})`,
        "clientName",
        250,
        1,
      ),
      renderCell: (params) => {
        return (
          <Grid2
            container
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-start"}
          >
            <Typography
              fontWeight={700}
              maxWidth={"100%"}
              textOverflow={"ellipsis"}
              overflow={"hidden"}
            >
              {params?.row?.clientName}
            </Typography>
            <Typography fontSize={12}>
              {params?.row?.portfolioName} - {params?.row?.portfolioId}
            </Typography>
          </Grid2>
        );
      },
    },
    {
      ...extraColumnsField("Fee Plan", "feePlanName", 200, 1),
    },
    {
      ...extraColumnsField("Start Date", "startingDate", 100, 1),
      type: "date",
      valueFormatter: (value) => matchDate(value?.value),
    },
    {
      ...extraColumnsField(
        "Total Fee Collected (₹)",
        "totalFeeCollected",
        150,
        1,
      ),
      valueGetter: (row) => row?.row?.totalFeeCollected,
      valueFormatter: (params) => moneyCommaSeparator(params.value || 0),
      type: "number",
    },
    {
      ...extraColumnsField(
        "Total Billed Generated (₹)",
        "totalFeeGenerated",
        150,
        1,
      ),
      valueGetter: (row) => row?.row?.totalFeeGenerated,
      valueFormatter: (params) => moneyCommaSeparator(params.value || 0),
      type: "number",
    },
    {
      ...extraColumnsField("Partner", "partnerName", 150, 1),
      valueGetter: (params) => params.row.partnerName || "-",
    },
  ];

  return (
    <GKDataGrid
      loading={isFetching}
      columns={columns}
      rows={data?.data || []}
      maxHeight={"calc(100vh - 312px)"}
      totalCount={data?.totalCount || 0}
      name="portfolioMapping"
      tableName="portfolio_mapping"
      onRowClick={(params) => {
        navigate(`/app/holdings/portfolio/${params.row.portfolio}/`);
        dispatch(TAB({ tabKey: "portfolioTabs", tabValue: 1 }));
        dispatch(TAB({ tabKey: "portfolioAdminViewTabs", tabValue: 7 }));
      }}
      emptyComponent={
        <NoData
          text="No Revenue Records Found"
          subText="Once transactions are processed, your revenue details will be displayed automatically."
          customImg={
            <RevenueIcon height={80} width={80} color="var(--neutral-100)" />
          }
        />
      }
    />
  );
};

export default RevenueManager;
